import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import workshop01 from '../../../images/workshop_images/workshop01.jpg';
import duration from '../../../images/workshop_images/duration.png';
import language from '../../../images/workshop_images/language.png';
import timings from '../../../images/workshop_images/timing.png';
import start_date from '../../../images/workshop_images/start-date.png';
import fees from '../../../images/workshop_images/money.png';
import location from '../../../images/workshop_images/loction.png';
import accept from '../../../images/workshop_images/accept.png';
import health_seekers from '../../../images/workshop_images/health_seekers.png';
import cross from '../../../images/workshop_images/cross.png';
import staticWorkshops, {
    resolveWorkshopCover,
    staticWorkshopFaqs,
} from '../../../data/staticWorkshops';
import {
    staticHost,
    staticIsThisYou,
    staticWhyJoin,
    staticWhatYoullLearn,
    staticWhoIsThisFor,
    resolveAssetUrl,
} from '../../../data/staticWorkshopDetail';
import { getApiBaseUrl } from '../../../utils/apiBase';
import './workshopdetails.css';

function CountdownTimer({ targetDate }) {
    const calculateTimeLeft = useCallback(() => {
        const difference = new Date(targetDate) - new Date();
        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / 1000 / 60) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            return { days, hours, minutes, seconds };
        }
        return null;
    }, [targetDate]);

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [calculateTimeLeft]);

    if (!timeLeft) {
        return <p className="text-danger">The workshop has started!</p>;
    }

    return (
        <div className="countdown-timer">
            <div className="time-box">
                <span>{timeLeft.days}</span>
                <small>Days</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.hours}</span>
                <small>Hours</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.minutes}</span>
                <small>Minutes</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.seconds}</span>
                <small>Seconds</small>
            </div>
        </div>
    );
}

function WorkshopDetails() {
    const { slug } = useParams();
    const [workshop, setWorkshop] = useState(null);
     const [topics, setTopics] = useState([]);
     const [learnTopics, setLearnTopics] = useState([]);
     const [questions, setQuestions] = useState([]);
  const [tagline, setTagline] = useState('');
      const [whoForData, setWhoForData] = useState([]);
      const [hostData, setHostData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
     const [accordionData, setAccordionData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    const baseURL = getApiBaseUrl();

    useEffect(() => {
        const fetchWorkshop = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${baseURL}/workshops/${slug}`);
                const apiWorkshop = response.data?.data || response.data;
                if (apiWorkshop && apiWorkshop.title) {
                    setWorkshop(apiWorkshop);
                } else {
                    const fallback = staticWorkshops.find((w) => w.slug === slug);
                    setWorkshop(fallback || null);
                    if (!fallback) setError('Workshop not found. Please try again.');
                }
            } catch (err) {
                console.error('Error fetching workshop:', err);
                const fallback = staticWorkshops.find((w) => w.slug === slug);
                setWorkshop(fallback || null);
                if (!fallback) setError('Workshop not found. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchWorkshop();
        AOS.init({ duration: 600, easing: 'ease-in-out' });
    }, [slug]);

    useEffect(() => {
        const fetchTopics = async () => {
            try {
                const response = await axios.get(
                    `${baseURL}/workshops/why-join/${slug}/`
                );
                const list = response.data?.data;
                setTopics(Array.isArray(list) && list.length ? list : staticWhyJoin);
            } catch (error) {
                console.error('Error fetching topics:', error);
                setTopics(staticWhyJoin);
            }
        };

        fetchTopics();
    }, [slug, baseURL]);

     useEffect(() => {
        const fetchLearnTopics = async () => {
            try {
                const response = await axios.get(
                    `${baseURL}/workshops/what-youll-learn/${slug}/`
                );
                const list = response.data?.data;
                setLearnTopics(Array.isArray(list) && list.length ? list : staticWhatYoullLearn);
            } catch (error) {
                console.error('Error fetching What You’ll Learn topics:', error);
                setLearnTopics(staticWhatYoullLearn);
            }
        };

        fetchLearnTopics();
    }, [slug, baseURL]);

     useEffect(() => {
        const fetchwhoForData = async () => {
            try {
                const response = await axios.get(
                   `${baseURL}/workshops/who-is-this-for/${slug}/`
                );
                const list = response.data?.data;
                setWhoForData(Array.isArray(list) && list.length ? list : staticWhoIsThisFor);
            } catch (error) {
                console.error('Error fetching who-is-this-for:', error);
                setWhoForData(staticWhoIsThisFor);
            }
        };

        fetchwhoForData();
    }, [slug, baseURL]);

     useEffect(() => {
  const fetchHostData = async () => {
    if (!workshop) return;

    if (!workshop.host_slug) {
      setHostData(staticHost);
      return;
    }

    try {
      const response = await axios.get(`${baseURL}/team_members/${workshop.host_slug}/`);
      const data = response.data?.data;
      setHostData(data?.name ? data : staticHost);
    } catch (error) {
      console.error('Error fetching host data:', error);
      setHostData(staticHost);
    }
  };

  fetchHostData();
}, [workshop, baseURL]); 

  useEffect(() => {
    const fetchIsThisYou = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/workshops/is-this-you/${slug}/`
        );
        const data = response.data?.data;
        if (data?.questions?.length) {
          setQuestions(data.questions);
          setTagline(data.tagline || staticIsThisYou.tagline);
        } else {
          setQuestions(staticIsThisYou.questions);
          setTagline(staticIsThisYou.tagline);
        }
      } catch (error) {
        console.error('Error fetching "Is This You?" data:', error);
        setQuestions(staticIsThisYou.questions);
        setTagline(staticIsThisYou.tagline);
      }
    };

    fetchIsThisYou();
  }, [slug, baseURL]);
    
  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/faq/${slug}/`
        );
        // The API returns qa_pairs as an array of arrays: [question, answer, id]
        const pairs = response.data?.data?.qa_pairs;
        if (Array.isArray(pairs) && pairs.length > 0) {
          setAccordionData(
            pairs.map(([question, answer]) => ({
              title: question,
              content: answer,
              type: 'text',
            }))
          );
          return;
        }
        setAccordionData(staticWorkshopFaqs);
      } catch (error) {
        console.error('Error fetching FAQ data:', error);
        setAccordionData(staticWorkshopFaqs);
      }
    };

    fetchFAQ();
  }, [slug, baseURL]);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

   

    if (loading) {
        return (
            <div className="loader-container">
                <div className="loader"></div>
                <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
            </div>
        );
    }

    if (error || !workshop) {
        return (
            <div className="container">
                <h2>{error || "Workshop not found. Please try again."}</h2>
                <NavLink to="/workshop" onClick={() => window.scrollTo(0, 0)}>
                    <button className="btn">Go Back</button>
                </NavLink>
            </div>
        );
    }

    return (
        <>
            <section className="book-section register_detail">
                <div className="container">
                    <div className="book register_book">
                        <div className="book-text" data-aos="fade-right" data-aos-duration="2000">
                            <h1 className="text-start">{workshop.title}</h1>
                            <h4 className="fw-bold text-start mb-4">
                                <strong>{workshop.subtitle}</strong>
                            </h4>
                            <div className="countdown mt-4">
                                <h5 className="mb-3 fw-bold text-start">Workshop Will Start In:</h5>
                                <CountdownTimer targetDate={`${workshop.date}T${workshop.start_time}`} />
                            </div>
                            <div className="how mt-4">
                                <NavLink
                                    to="/contact"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    <button type="button" className="btn">Register Now</button>
                                </NavLink>
                            </div>
                            <p className="mt-4">
                                <strong style={{ color: '#9D3B24' }}>{workshop.tagline}</strong>
                            </p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img
                                src={resolveWorkshopCover(workshop, workshop01)}
                                alt={workshop.title}
                                srcSet=""
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="is_this_you-section">
      <div className="container">
        <h1 className="text-center offering-title mb-5">{tagline || 'Is This You?'}</h1>
        <div className="is_this_you">
          <ul>
            {questions.map((q, idx) => (
              <li key={idx}>
                <strong>{q}</strong>
              </li>
            ))}
          </ul>
          <h3 className="fw-bold text-success">
            If you answered 'YES' to any of the above, this workshop is for you!
          </h3>
        </div>
      </div>
    </section>

            <section className="info-section" id="workshop_details">
                <div className="details">
                    <h2 className="text-center fw-bold mb-4">Details Of The Workshop</h2>
                    <div className="all-details workshop-details">
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={start_date} alt="" />
                                <strong>Date:</strong> {new Date(workshop.date).toLocaleDateString('en-GB', {
                                                            day: 'numeric', month: 'long', year: 'numeric'
                                                        })}
                            </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={language} alt="" />
                                <strong>Language:</strong> {workshop.languages.join(' and ')}
                            </h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={timings} alt="" />
                                <strong>Timings:</strong> {workshop.start_time.slice(0, 5)} - {workshop.end_time.slice(0, 5)} IST
                            </h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={duration} alt="" />
                                <strong>Duration:</strong> {workshop.duration}
                            </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={fees} alt="" />
                                <strong>Course Fee:</strong> <s>Rs. {parseFloat(workshop.course_fee_original).toFixed(0)}</s> Rs. {parseFloat(workshop.course_fee_discounted).toFixed(0)}
                            </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className="text-start">
                                <img src={location} alt="" />
                                <strong>Location:</strong> {workshop.location.charAt(0).toUpperCase() + workshop.location.slice(1)}
                            </h5>
                        </div>
                    </div>
                </div>
            </section>

            <section className="why-join-section pillar-section">
            <div className="container">
                <div className="pillar">
                    <h2 className="mb-4" data-aos="fade-down" data-aos-duration="3000">
                        <strong style={{ color: '#9D3B24' }}>Why Join This Workshop?</strong>
                    </h2>
                    <h4
                        className="fw-bold mb-5 offering-title"
                        data-aos="fade-down"
                        data-aos-duration="3000"
                    >
                        This isn’t just another health talk—it’s an actionable and inspiring session
                        designed to help you start early and stay consistent on your wellness journey.
                    </h4>
                </div>

                <div className="all-pillar">
                    {topics.map((topic) => (
                        <div className="pillar-detail" key={topic.id}>
                            <div className="pillar-image">
                                <img
                                    src={resolveAssetUrl(topic, 'logo', baseURL, health_seekers)}
                                    alt={topic.title}
                                />
                            </div>
                            <div className="pillar-text">
                                <h5 className="fw-bold">{topic.title}</h5>
                                <h6 className="fw-bold custom-justify">{topic.tagline}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

            <section className="what_learn-section" id="workshop_details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="include">
                            <h1 className="text-center">What You’ll Learn?</h1>
                            <h5 className="fw-bold text-center">
                                We’ll break it down into simple, fun, and insightful lessons.
                            </h5>

                            {learnTopics.map((topic) => (
                                <div className="include-details" key={topic.id}>
                                    <div className="include-images">
                                        <img
                                            src={resolveAssetUrl(topic, 'logo', baseURL, learnTopics[0]?.logo || workshop01)}
                                            alt={topic.title}
                                        />
                                    </div>
                                    <div className="include-text">
                                        <h2 className="fw-bold text-start">{topic.title}</h2>
                                        <ul className="text-start">
                                            {String(topic.description || '')
                                                .split('.')
                                                .filter((sentence) => sentence.trim() !== '')
                                                .map((point, idx) => (
                                                    <li key={idx}>{point.trim()}.</li>
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-3">
                        <NavLink to="/contact" onClick={() => window.scrollTo(0, 0)}>
                            <div className="right-block">
                                <h4 className="fw-bold">
  {(() => {
    const words = workshop.title.split(' ');
    const breakIndex = 4; // Insert <br /> after this many words

    if (words.length <= breakIndex) {
      return workshop.title;
    }

    return (
      <>
        {words.slice(0, breakIndex).join(' ')}<br />
        {words.slice(breakIndex).join(' ')}
      </>
    );
  })()}
</h4>

                                <h6 className="text-dark fw-bold mb-4">
                                   {workshop.subtitle}
                                </h6>
                                <ul className="text-start">
                                    <li className="fw-bold text-dark">
                                        <img src={start_date} alt="" />
                                       {new Date(workshop.date).toLocaleDateString('en-GB', {
                                                            day: 'numeric', month: 'long', year: 'numeric'
                                                        })}
                                    </li>
                                    <li className="fw-bold text-dark">
                                        <img src={fees} alt="" />
                                        Fees: <s>Rs. {parseFloat(workshop.course_fee_original).toFixed(0)}</s> Rs. {parseFloat(workshop.course_fee_discounted).toFixed(0)}
                                    </li>
                                    <li className="fw-bold text-dark">
                                        <img src={timings} alt="" />
                                        {workshop.start_time.slice(0, 5)} - {workshop.end_time.slice(0, 5)} IST
                                    </li>
                                </ul>
                                <h5 className="fw-bold">{workshop.tagline}</h5>
                                <h6 className="fw-bold text-dark">
                                    Begin your journey to a healthy, meaningful life in just 90 minutes—don’t miss out!
                                </h6>
                                <div className="how mt-4">
                                    <button type="button" className="btn">Register Now</button>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>
        </section>

           <section className="host-section" id="workshop_details">
  <div className="container">
    <div className="row">
      <div className="col-lg-9">
        <h1 className="mb-2 mt-5">About Our Host</h1>

        <div className="host">
          <div className="host-image">
            <img
              src={resolveAssetUrl(hostData || staticHost, 'profile_photo', baseURL, '/images/prgati_jain.png')}
              alt={(hostData || staticHost).name}
            />
          </div>
          <div className="host-text">
            <h2 className="fw-bold">{(hostData || staticHost).name}</h2>
            {String((hostData || staticHost).biography || '')
              .split('\n')
              .filter(Boolean)
              .map((para, i) => (
                <p key={i} className="custom-justify">{para}</p>
              ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            <section className="yes-section" id="workshop_details">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="yes">
              <div className="yes-header">
                <h1>Who is this for?</h1> <img src={accept} alt="" />
              </div>
              <h5 className="fw-bold text-start">
                The course is designed for everyone seeking a balanced and healthier lifestyle.
              </h5>
              <div className="all-information">
                {whoForData.map((item) => (
                  <div className="details" key={item.id}>
                    <div className="details-image">
                      <img
                        src={resolveAssetUrl(item, 'logo', baseURL, health_seekers)}
                        alt={item.title}
                      />
                    </div>
                    <div className="details-text">
                      <h4 className="fw-bold">{item.title}</h4>
                      <h5 className="fw-bold">{item.tagline || item.description}</h5>
                    </div>
                  </div>
                ))}
              </div>
              <div className="yes-header mt-5">
                <h1>Who is it not for?</h1> <img src={cross} alt="" />
              </div>
              <h5 className="fw-bold text-start">
                This program isn't suitable for those not serious about their health.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>

            <section className="register_faq-section" id="workshop_details">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="register-faq">
              <h1>FAQs</h1>
              <div className="faq-image">
                <img src={resolveWorkshopCover(workshop, workshop01)} alt="" />
              </div>
              <div className="accordion justify-content-center">
                {accordionData.map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <button
                      className="accordion-button"
                      aria-expanded={activeIndex === index ? 'true' : 'false'}
                      onClick={() => toggleAccordion(index)}
                    >
                      <span className="accordion-title">{item.title}</span>
                      <span className="icon" aria-hidden="true"></span>
                    </button>
                    {activeIndex === index && (
                      <div className="accordion-content">
                        {item.type === 'list' ? (
                          <ul>
                            {item.content.map((listItem, i) => (
                              <li key={i}>{listItem}</li>
                            ))}
                          </ul>
                        ) : (
                          <p>{item.content}</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        </>
    );
}

export default WorkshopDetails;